"use client";

import { memo, useState } from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";
import {
  useA2UIComponent,
  ComponentNode,
  type A2UIComponentProps,
  type Types,
} from "@a2ui/react";

export const BeeOSTabs = memo(function BeeOSTabs({
  node,
  surfaceId,
}: A2UIComponentProps<Types.TabsNode>) {
  const { resolveString } = useA2UIComponent(node, surfaceId);
  const props = node.properties;
  const tabItems = props.tabItems ?? [];
  const [selectedTab, setSelectedTab] = useState("tab-0");

  const hostStyle: React.CSSProperties =
    node.weight !== undefined
      ? ({ "--weight": node.weight } as React.CSSProperties)
      : {};

  return (
    <div className="a2ui-tabs" style={hostStyle}>
      <TabsPrimitive.Root value={selectedTab} onValueChange={setSelectedTab}>
        <TabsPrimitive.List className="inline-flex h-10 items-center justify-start rounded-md bg-muted/60 backdrop-blur-sm p-1 text-muted-foreground">
          {tabItems.map((tab, index) => {
            const title = resolveString(tab.title);
            return (
              <TabsPrimitive.Trigger
                key={`tab-${index}`}
                value={`tab-${index}`}
                className="inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-[0_1px_3px_rgba(0,0,0,0.06),0_0_0_1px_rgba(0,0,0,0.03)] dark:data-[state=active]:shadow-[0_1px_3px_rgba(0,0,0,0.2),0_0_0_1px_rgba(255,255,255,0.04)]"
              >
                {title}
              </TabsPrimitive.Trigger>
            );
          })}
        </TabsPrimitive.List>
        {tabItems.map((tab, index) => (
          <TabsPrimitive.Content
            key={`content-${index}`}
            value={`tab-${index}`}
            className="mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          >
            <ComponentNode node={tab.child} surfaceId={surfaceId} />
          </TabsPrimitive.Content>
        ))}
      </TabsPrimitive.Root>
    </div>
  );
});
